import { client } from 'lib/evi-api-gateway';

import {
  add_v2_params,
  get_course_level_params,
  get_list_v2_params,
  get_params,
  update_course_publish_status_params,
  get_course_tab_count_list_params,
  batch_delete_course_params,
  batch_archive_params,
  delete_course_params,
  get_progress_by_course_id_params,
  get_progress_by_class_id_params,
  get_student_progress_params
} from 'types/schoolBasedActivity';

const course = `${process.env.REACT_APP_API_URL_RESOURCE}/api/course`;

export async function add_v2(params: add_v2_params) {
  return client.post({
    url: `${course}/add_v2`,
    form: {
      ...params,
      garten_version: 2
      // is_hot: 'N',
      // status: params.status || 'VALID'
    }
  });
}

export async function get_course_level(params: get_course_level_params) {
  return client.post({
    url: `${course}/get_course_level`,
    form: {
      ...params
    }
  });
}

export async function get_list_v2(params: get_list_v2_params) {
  return client.post({
    url: `${course}/get_list_v2`,
    form: {
      ...params
    }
  });
}

export async function get(params: get_params) {
  return client.post({
    url: `${course}/get`,
    form: {
      ...params
    }
  });
}

export async function update_course_publish_status(params: update_course_publish_status_params) {
  return client.post({
    url: `${course}/update_course_publish_status`,
    form: {
      ...params
    }
  });
}

export async function get_course_tab_count_list(params: get_course_tab_count_list_params) {
  return client.post({
    url: `${course}/get_course_tab_count_list`,
    form: {
      ...params
    }
  });
}

export async function delete_course(params: delete_course_params) {
  return client.post({
    url: `${course}/delete`,
    form: {
      ...params
    }
  });
}

export async function batch_delete_course(params: batch_delete_course_params) {
  return client.post({
    url: `${course}/batch_delete`,
    form: {
      ...params
    }
  });
}

export async function batch_archive(params: batch_archive_params) {
  return client.post({
    url: `${course}/batch_archive`,
    form: {
      ...params
    }
  });
}

export async function updateHot(params: any) {
  return client.post({
    url: `${course}/update_hot`,
    form: {
      ...params
    }
  });
}

// 浏览情况
export async function get_progress_by_course_id(params: get_progress_by_course_id_params) {
  return client.post({
    url: `${course}/get_progress_by_course_id`,
    form: {
      ...params
    }
  });
}

// 浏览情况-班級
export async function get_progress_by_class_id(params: get_progress_by_class_id_params) {
  return client.post({
    url: `${course}/get_progress_by_class_id`,
    form: {
      ...params
    }
  });
}

// 浏览情况-班級-学生
export async function get_student_progress(params: get_student_progress_params) {
  return client.post({
    url: `${course}/get_student_progress`,
    form: {
      ...params
    }
  });
}
